import {Component, OnInit} from '@angular/core';
import {AdminPageModelComponent} from "../../components/admin/admin-page-model/admin-page-model.component";
import {UserService} from "../../services/user.service";
import {Observable} from "rxjs";
import {UserRequest} from "../../model/UserRequest";
import {UserRequestsComponent} from "../../components/admin/user-requests/user-requests.component";

@Component({
    selector: 'app-user-add-request',
    imports: [
        AdminPageModelComponent,
        UserRequestsComponent
    ],
    templateUrl: './user-add-request.component.html',
    styleUrl: './user-add-request.component.scss'
})
export class UserAddRequestComponent implements OnInit {

  requests = new Observable<UserRequest[]>();

  constructor(private userRequestService: UserService) {
  }

  ngOnInit(): void {
    this.requests = this.userRequestService.listRequests();
  }

}
